enum AppRoute {
  Dashboard = '/',
  Login = '/login',
  Monoova = '/monoova'
}

export default AppRoute;
